module.exports = __webpack_public_path__ + "static/img/flutter1.74806600.png";